import { Mapper } from "../../../../base/utils/mapper";
import { StateProspectModel } from "../../../../domain/models/configuration/state-prospect.model";
import { StateProspectEntity } from "../entities/state-prospect.entity";

export class StateProspectImplementationRepositoryMapper extends Mapper<StateProspectEntity, StateProspectModel> {
    mapFrom(param: StateProspectEntity): StateProspectModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: StateProspectModel): StateProspectEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}